import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';

// Components
import CustomButton from '../../components/CustomButton';
import FormikTextField from '../../components/form/FormikTextField';

// Prime-React Components
import { Sidebar } from 'primereact/sidebar';

// Redux-Actions
import {
  addJobDesignation,
  editJobDesignation,
  getJobDesignationById
} from '../../redux/actions/designation';

// Redux-Slices
import { apiStatusClear } from '../../redux/slices/apiStatus';
import { updateData } from '../../redux/slices/designation';

// Constants
import { BUTTON_TYPES, LABEL_TYPES } from '../../constants/common';
import { addEditJobDesignationSchema } from '../../schema/masterData.Schema';

const AddEditJobDesignation = (props) => {
  const dispatch = useDispatch();
  const { show, ID, onHide } = props;
  const { designationDetails } = useSelector((state) => state.designation);
  const { isSucceed, isLoading } = useSelector((state) => state.apiStatus);
  const [isUpdatedSuccess, setIsUpdatedSuccess] = useState(false);
  const [jobDesignationData, setJobDesignationData] = useState({
    designation: ''
  });

  useEffect(() => {
    ID && dispatch(getJobDesignationById(ID));
  }, [dispatch, ID]);

  useEffect(() => {
    if (ID && designationDetails && Object.keys(designationDetails).length !== 0) {
      setJobDesignationData({
        designation: `${designationDetails?.Designation}`
      });
    }
  }, [designationDetails]);

  useEffect(() => {
    if (show && isUpdatedSuccess && isSucceed) {
      onHide(false);
      formik.resetForm();
      document.body.classList.remove('sidebar-open');
      dispatch(updateData());
      dispatch(apiStatusClear());
      setJobDesignationData({
        designation: ''
      });
      setIsUpdatedSuccess(false);
    }
  }, [isSucceed]);

  useEffect(() => () => setIsUpdatedSuccess(false), []);

  const formik = useFormik({
    initialValues: jobDesignationData,
    validationSchema: addEditJobDesignationSchema,
    onSubmit: (values) => handleSubmit(values),
    enableReinitialize: true
  });

  const handleSubmit = (values) => {
    if (ID) {
      dispatch(
        editJobDesignation({
          formdata: { ...values },
          ID: ID
        })
      );
    } else {
      dispatch(
        addJobDesignation({
          designation: values.designation?.trim()
        })
      );
    }
    setIsUpdatedSuccess(true);
  };

  return (
    <Sidebar
      ID={ID}
      visible={show}
      onHide={() => {
        onHide(true);
        document.body.classList.remove('sidebar-open');
      }}
      position="right"
      className="sidebar-drawer">
      <div className="form-box-wrapper">
        <div className="title-wrapper">
          <p className="card-title">{ID ? 'Edit' : 'Add'} Job Designation</p>
          <button
            className="p-sidebar-close"
            onClick={() => {
              onHide(false);
              document.body.classList.remove('sidebar-open');
              setJobDesignationData({
                designation: ''
              });
              formik.resetForm();
            }}>
            <span className="p-sidebar-close-icon pi pi-times" />
          </button>
        </div>
        <form onSubmit={formik.handleSubmit} className="p-fluid" autoComplete="off">
          <div className="form-row-wrapper">
            <div className="form-col full-width">
              <div className="form-group-outer">
                <div className="custom-form-group">
                  <FormikTextField
                    labelText={LABEL_TYPES.DESIGNATION}
                    isMandatory
                    formik={formik}
                    name="designation"
                    placeholder={LABEL_TYPES.DESIGNATION + ' *'}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="form-btn-wrapper">
            <CustomButton type="submit" variant="contained" className="" disabled={isLoading}>
              {BUTTON_TYPES.SAVE}
            </CustomButton>
            <CustomButton
              variant="contained"
              onClick={() => {
                onHide(false);
                document.body.classList.remove('sidebar-open');
                setJobDesignationData({
                  designation: ''
                });
                formik.resetForm();
              }}
              color="error"
              className="gray-btn">
              {BUTTON_TYPES.CANCEL}
            </CustomButton>
          </div>
        </form>
      </div>
    </Sidebar>
  );
};

export default AddEditJobDesignation;
